<template>
    <div>
        <div v-if="series === null || treatments === null" class="ckp-muted ckp-loading">Chargement…</div>
        <div v-else-if="entries.length === 0" class="ckp-empty">Pas d'abonnement ni de cure en cours pour ce client.</div>
        <section v-for="group in groups" :key="group.type" class="ckp-group">
            <div class="ckp-section-head">
                <h3 class="ckp-title">{{ group.title }}</h3>
                <span class="ckp-hint">{{ group.count }}</span>
            </div>
            <div v-for="entry in group.entries" :key="entry.type + '-' + entry.item.id" class="ckp-card">
                <div class="ckp-card-head">
                    <strong>{{ entry.item.name }}</strong>
                    <span class="ckp-pill">{{ plural(entry.item.pivot.quantity_left, 'séance restante', 'séances restantes') }}</span>
                </div>
                <div class="ckp-card-body">
                    <span class="ckp-card-meta">{{ details(entry) }}</span>
                    <button
                        v-if="posed(entry)"
                        type="button"
                        class="ckp-remove-link"
                        @click="removePrestations(entry.item.id, entry.type)"
                    >
                        Retirer du panier
                    </button>
                    <button
                        v-else
                        type="button"
                        class="ck-button ck-button-small"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-select-prestas"
                        @click="changeSelected(entry.item, entry.type)"
                    >
                        Appliquer au panier
                    </button>
                </div>
            </div>
        </section>
        <p v-if="entries.length" class="ckp-hint ckp-hint-block">Appliquer un abonnement ou une cure décompte une séance et réduit le reste dû d'autant.</p>
        <serie-treatment-modal
            :selected="selected"
            @remove-selected="resetSelected"
        ></serie-treatment-modal>
    </div>
</template>

<script>
import ApiManager from './_core/ApiManager'
import { sync, get } from 'vuex-pathify'

export default {
    data: () => ({
        treatments: null,
        series: null,
        selected: null,
        prepaidPrestations: [],
    }),
    async mounted() {
        if (!this.c_customer?.id) return
        await ApiManager.getSeries(this.c_customer.id).then(res => (this.series = res))
        await ApiManager.getTreatments(this.c_customer.id).then(res => (this.treatments = res))
    },
    computed: {
        c_overlay: sync('overlay'),
        entries() {
            return [
                ...(this.series || []).map(item => ({ item, type: 'serie' })),
                ...(this.treatments || []).map(item => ({ item, type: 'treatment' })),
            ]
        },
        // Abonnements puis cures, chacun avec son compteur
        groups() {
            const series = this.entries.filter(entry => entry.type === 'serie')
            const treatments = this.entries.filter(entry => entry.type === 'treatment')
            return [
                { type: 'serie', title: 'Abonnements', entries: series, count: this.plural(series.length, 'actif', 'actifs') },
                { type: 'treatment', title: 'Cures', entries: treatments, count: `${treatments.length} en cours` },
            ].filter(group => group.entries.length)
        },
        ...sync('overlay@data', {
            c_payments: 'payments',
            c_prepaidPrestations: 'prepaidPrestations'
        }),
        ...get('overlay@data', {
            c_customer: 'customer',
            c_cartItems: 'cartItems',
        }),
    },
    methods: {
        // La modale pose les séances du panier couvertes par la formule (watch de « selected ») : on repasse par null
        // pour qu'une formule retirée puis ré-appliquée déclenche à nouveau le watch
        changeSelected(item, type) {
            item.type = type
            this.selected = null
            this.$nextTick(() => { this.selected = item })
        },
        // Séances de cette formule déjà posées dans le panier
        posed(entry) {
            return (this.c_prepaidPrestations || []).filter(p => p.prepaid && p.prepaid.id == entry.item.id && p.prepaid.type == entry.type).length
        },
        plural(count, one, many) {
            return `${count} ${count > 1 ? many : one}`
        },
        details(entry) {
            const pivot = entry.item.pivot || {}
            const parts = []
            if (entry.type === 'serie') {
                if (pivot.expires_at) {
                    parts.push(`Valable jusqu'au ${this.formatDate(pivot.expires_at)}`)
                    const days = Math.ceil((new Date(String(pivot.expires_at).replace(' ', 'T')) - new Date()) / 86400000)
                    if (days >= 0 && days <= 30) parts.push(days === 0 ? "expire aujourd'hui" : `expire dans ${this.plural(days, 'jour', 'jours')}`)
                } else {
                    parts.push('Sans date de fin')
                }
            } else {
                if (pivot.created_at) parts.push(`Démarrée le ${this.formatDate(pivot.created_at)}`)
                // quantity vaut souvent 0 en base : à défaut, nombre de séances de la cure
                const total = Number(pivot.quantity) || Number(entry.item.prestations_qty) || 0
                const used = total - Number(pivot.quantity_left)
                if (total && used >= 0) parts.push(this.plural(used, 'séance consommée', 'séances consommées'))
            }
            const posed = this.posed(entry)
            if (posed) parts.push(`${this.plural(posed, 'séance déjà posée', 'séances déjà posées')} dans ce panier`)
            return parts.join(' · ')
        },
        formatDate(date) {
            const d = new Date(String(date).replace(' ', 'T'))
            return isNaN(d) ? date : d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
        },
        resetSelected() {
            this.selected = null
        },
        removePrestations(prepaidId, prepaidType) {
            this.c_prepaidPrestations = this.c_prepaidPrestations.filter(p => !(p.prepaid.id == prepaidId && p.prepaid.type == prepaidType))
        },
    },
}
</script>
